// extracted by mini-css-extract-plugin
module.exports = {"builder":"_5b10bb2305--builder--q7JCH","image":"_5b10bb2305--image--by9AA","title":"_5b10bb2305--title--zFDR0"};